module.exports = __webpack_public_path__ + "img/full3-min.18a4b6a0.png";